import { render } from "./ProyectosView.vue?vue&type=template&id=ab337612"
import script from "./ProyectosView.vue?vue&type=script&lang=js"
export * from "./ProyectosView.vue?vue&type=script&lang=js"

import "./ProyectosView.vue?vue&type=style&index=0&id=ab337612&lang=css"

import exportComponent from "D:\\gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__